import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { BonusInfoDesc, BorderSec } from 'src/components/Bonus';
import Intl from "./common/Intl";

function WelcomeBonus61(props: any) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return (
        <InformationWrapper>
            <BonusInfoContainer>
                <BonusInfoHeadH1><Intl langKey="PROMOTIONSWELCOME@HeadingH1" /></BonusInfoHeadH1>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOME@FIRSTLINE" /></BonusInfoDesc>
            </BonusInfoContainer>
            <BonusInfoContainer>
                <BonusInfoDesc><Intl langKey="PROMOTIONSWELCOME@SECONDLINEINFO" /></BonusInfoDesc>
                <ol type="a">
                    <li className='bold'><Intl langKey="PROMOTIONSWELCOME@CryptoLI" /></li>
                    <li className='bold'><Intl langKey="PROMOTIONSWELCOME@CryptoLI2" /></li>
                    <li className='bold'><Intl langKey="PROMOTIONSWELCOME@CryptoLI3" /></li>
                </ol>
            </BonusInfoContainer>
            <BonusInfoContainer>
                <BonusInfoHeadH3><Intl langKey="PROMOTIONSWELCOME@HowDoesitWork" /></BonusInfoHeadH3>
                <BonusInfoDesc>
                    <ul>
                        <li><Intl langKey="PROMOTIONSWELCOME@HowDoesitWork1" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOME@HowDoesitWork2" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOME@HowDoesitWork3" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOME@HowDoesitWork4" /></li>
                    </ul>
                </BonusInfoDesc>
            </BonusInfoContainer>
            <BonusInfoContainer>
                <BonusInfoHeadH3><Intl langKey="PROMOTIONSWELCOME@TERMS" /></BonusInfoHeadH3>
                <BonusInfoDesc>
                    <ol>
                        <li><Intl langKey="PROMOTIONSWELCOME@TERMS1" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOME@TERMS2" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOME@TERMS3" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOME@TERMS4" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOME@TERMS5" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOME@TERMS6" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOME@TERMS7" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOME@TERMS8" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOME@TERMS9" /></li>
                        <li><Intl langKey="PROMOTIONSWELCOME@TERMS10" /></li>
                    </ol>
                </BonusInfoDesc>
            </BonusInfoContainer>
        </InformationWrapper>
    )
}

export default withTheme(withAppContext(WelcomeBonus61));

// Styled Component.
const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 3rem;
    border:1px solid white;
    border-radius: 1px;
    background: rgba(111, 111, 111, 0.5);
    margin: 0em 1.2em;
    backdrop-filter: brightness(0.5);

    & ul li {
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 25px;
        text-align: justify;
        -webkit-letter-spacing: 0.01em;
        -moz-letter-spacing: 0.01em;
        -ms-letter-spacing: 0.01em;
        letter-spacing: 0.01em;
        text-transform: capitalize;
        color: #FFFFFF;
        margin: 5px 0px;
    }

    & span {
        display: flex;
        flex-direction: column; 
        right: 0px;
        width: auto;
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        text-transform: capitalize;
        color: #FFFFFF;
        align-items: flex-end;

        @media only screen and (min-width: 1700px){
            font-size: 16px;
        }
    }
`;

const BonusInfoContainer = styled.div`
   width: 100%;
   margin: auto;

   & h6 {
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0.01em;
        text-transform: capitalize;
        color: #C2D2FF;
        margin: 25px 0px 20px 0px;
    }

   & h5 {
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 25px;
        text-align: justify;
        letter-spacing: 0.01em;
        text-transform: capitalize;
        color: #FFFFFF;
        margin: 5px 0px;
    }

   & ul,li {
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 25px;
        text-align: justify;
        letter-spacing: 0.01em;
        text-transform: capitalize;
        color: #FFFFFF;
    }

    .bold {
        font-weight: bold;
        font-size: 14px;
    }
`;

const BonusInfoHeadH2 = styled.h2`
    font-style: normal;
    font-weight: 700;
    font-size: 19px;
    line-height: 29px;
    letter-spacing: 0.01em;
    text-transform: capitalize;
    color: #E3B73E;
    margin: 15px 0px;
`;

const BonusInfoHeadH3 = styled.h3`
    font-style: normal;
    font-weight: 700;
    line-height: 29px;
    letter-spacing: 0.01em;
    text-transform: capitalize;
    color: #E3B73E;
    margin: 15px 0px;
`;

const BonusInfoHeadH1 = styled.h1`
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 29px;
    letter-spacing: 0.01em;
    text-transform: capitalize;
    color: #E3B73E;
    margin: 15px 0px;
`;

const BonusInfoHead = styled.h4`
    font-style: normal;
    font-weight: 700;
    font-size: 19px;
    line-height: 29px;
    letter-spacing: 0.01em;
    text-transform: capitalize;
    color: #E3B73E;
    margin: 15px 0px;
`;

const PLWrap = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
`;

const PlLeft = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const PlRight = styled.div``;